import { useState } from "react";
import { bemCN } from "../../config/bem-classname";
import { authService } from "../../services/auth-service";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import "./login-page.scss";
import { SignInRequestDTO } from "../../api/Api";
import { ReactComponent as MessageIcon } from "../../shared/images/svg/message.svg";
import { ReactComponent as LockIcon } from "../../shared/images/svg/lock.svg";
import { Input, TypeDataInput, TypeViewInput } from "../../ui/input/input";
import { Link, useNavigate } from "react-router";
import { links } from "../../config/links";

const loginPageCn = bemCN("login-page");

export const LoginPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<SignInRequestDTO>({
    email: "",
    password: "",
  });
  const [errorText, setErrorText] = useState<string>();

  const onClickLogin = () => {
    setErrorText(undefined);
    authService.login(user).then((res: any) => {
      if (res == 200) {
        navigate(links.stories);
      } else {
        setErrorText(res);
      }
    });
  };

  return (
    <div className={loginPageCn()}>
      <h1>Войдите в аккаунт</h1>
      <div className={loginPageCn("inputs")}>
        <Input
          onChange={(v: string) => setUser({ ...user, email: v })}
          icon={<MessageIcon />}
          placeholder="Email"
          value={user?.email}
          typeView={TypeViewInput.text}
          typeData={TypeDataInput.text}
        />
        <Input
          icon={<LockIcon />}
          placeholder="Пароль"
          value={user?.password}
          typeView={TypeViewInput.password}
          typeData={TypeDataInput.password}
          onChange={(v: string) => setUser({ ...user, password: v })}
        />
      </div>
      <Link to={links.recoveryPassword}>Забыли пароль?</Link>
      {errorText && <p>{errorText}</p>}
      <Button
        onClick={onClickLogin}
        text="Войти"
        color={ButtonColors.green}
        size={ButtonSizes.big}
      />
      <Link to={links.reg}>Зарегистрироваться</Link>
    </div>
  );
};
